import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbf8dd22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-top common-wrap" }
const _hoisted_2 = { class: "header-top-left" }
const _hoisted_3 = { class: "tabbar" }
const _hoisted_4 = ["onClick"]

import useHomeStore from '@/store/modules/home'
import { storeToRefs } from 'pinia'
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import LoginRegister from '@/components/header/components/login-register.vue'
import SubjectStage from '@/components/header/components/subject-stage.vue'




export default {
  __name: 'header-personspace',
  setup(__props) {

const router = useRouter()

const homeStore = useHomeStore()
const { showScrollHeader, defaultTab, showUpload, isLogin, showLogin, } = storeToRefs(homeStore)



const itemClick = (item, index) => {


  if(item.name == '精品课堂'){
    window.open('#/pcourse','_blank')
    return
  }
  defaultTab.value = index
  router.push(item.path)
}

const tabbar = [
  {
    path: '/home',
    name: '首页'
  },
  {
    path: '/pcourse',
    name: '精品课堂'
  },
  {
    path: '/home/cousrseResources',
    name: '微课资源'
  },
  {
    path: '/home/documents',
    name: '教学文档'
  },
  {
    path: '/home/achievements',
    name: '研修成果'
  },


]

const goHome = () => {
  defaultTab.value = 0
  router.push('/home')
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", { onClick: goHome }, "教师资源库"),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabbar, (item, index) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["tabbar-item", _unref(defaultTab) ==  index ? 'checked' :'']),
            onClick: $event => (itemClick(item, index)),
            key: index
          }, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["horizontal-line", _unref(defaultTab) ==  index ? 'checked' :''])
            }, null, 2)
          ], 10, _hoisted_4)
        }), 64))
      ])
    ]),
    _createVNode(LoginRegister)
  ]))
}
}

}